import * as React from 'react'
import {connect} from 'react-redux'
import {IAppStore, IAppUser} from '../../interfaces/reducers'
import SingleTableContainer from '../Tables/SingleTableContainer'
import AppMapLayersControl from '../Map/AppMapLayersControl'
import {appMapDispatcher} from '../../dispatchers/appMapDispatcher'
import {appSourcesDispatcher} from '../../dispatchers/appSourcesDispatcher'
import {IMapDispatcher, ISourcesDispatcher, IDataQueriesDispatcher} from '../../core/interfaces/dispatchers'
import FeatureCreator from '../FeatureViews/FeatureCreator'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {IFeatureLayerInfos} from '../../core/interfaces/reducers'
import AppExportSelector from '../Map/AppExportSelector'
import {ImportsContainer} from '../Import/ImportsContainer'
import {HistoryTypeSelector} from '../RegHistory/HistoryTypeSelector'
import {appDataQueriesDispatcher} from '../../dispatchers/appDataQueriesDispatcher'
import {Main} from '../ArchImport/Main'
interface OwnProps {
  currentlySelected: string
  sourcesImported: boolean
  mobile: boolean
  user?: IAppUser
  layerInfos: IFeatureLayerInfos
}

interface ParentProps {
  long: boolean
}

interface DispatchProps extends IMapDispatcher, ISourcesDispatcher, IDataQueriesDispatcher {}
type Props = OwnProps & DispatchProps & ParentProps
const SidebarContentContainer = (props: Props) => {
  const getCurrentContent = (): JSX.Element => {
    switch (props.currentlySelected) {
      case 'basemapsControl':
        return (
          <AppMapLayersControl
            dataQueryDispatcher={props}
            hideLegend={true}
            hideLayerList={true}
            currentlySelected="basemapsControl"
          />
        )
      case 'layersControl':
        return (
          <AppMapLayersControl
            dataQueryDispatcher={props}
            hideLegend={true}
            hideBasemaps={true}
            layerListWithLegend={true}
          />
        )
      case 'creator':
        return <FeatureCreator />
      case 'exportMapControl':
        return <AppExportSelector />
      case 'importControl':
        return <ImportsContainer mapDispatcher={props} />
      case 'regHistoryControl':
        return <HistoryTypeSelector />
      case 'archImport':
        return <Main />
      default:
        return <SingleTableContainer />
    }
  }

  return props.sourcesImported ? (
    getCurrentContent()
  ) : (
    <div style={{position: 'relative', height: '100%'}}>
      <OverlayLoader />
    </div>
  )
}

const mapStateToProps = (state: IAppStore) => ({
  currentlySelected: state.sidebar.currentlySelected,
  sourcesImported: state.map.sourcesImported,
  mobile: state.application.mobile,
  user: state.userInfo.user,
  layerInfos: state.layerInfos.featureLayerInfos
})

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appMapDispatcher,
  ...appSourcesDispatcher,
  ...appDataQueriesDispatcher
})(SidebarContentContainer)
